import { showMap } from "./map";
import { generateColumns } from "./links";
import { signIn, logout, isLoggedIn } from "./auth";
import { runCrossMatch } from "./zone-agent";

Office.onReady(async () => {
  document.getElementById("app-body")!.style.display = "flex";

  // Attach handlers
  document.getElementById("btn_generate_columns")!.onclick = generateColumns;
  document.getElementById("btn_show_map")!.onclick = showMap;
  document.getElementById("btn_crossmatch_zones")!.onclick = runCrossMatch;
  document.getElementById("btn_login")!.onclick = async () => {
    await signIn();
    await updateUiState();
  };
  document.getElementById("btn_logout")!.onclick = async () => {
    await logout();
    await updateUiState();
  };

  // Initialize UI state
  await updateUiState();
});

async function updateUiState() {
  const loggedIn = await isLoggedIn();

  // Enable/disable feature buttons
  //(document.getElementById("btn_generate_columns") as HTMLButtonElement).disabled = !loggedIn;
  // (document.getElementById("btn_show_map") as HTMLButtonElement).disabled = !loggedIn;
  (document.getElementById("btn_crossmatch_zones") as HTMLButtonElement).disabled = !loggedIn;

  // Toggle login/logout buttons
  (document.getElementById("btn_login") as HTMLButtonElement).disabled = loggedIn;
  (document.getElementById("btn_logout") as HTMLButtonElement).disabled = !loggedIn;
}

export function getCheckedColumns(): string[] {
  return Array.from(
    document.querySelectorAll<HTMLInputElement>("input[type='checkbox'][data-header]")
  )
    .filter(cb => cb.checked)
    .map(cb => cb.dataset.header!);
}
